import { render, staticRenderFns } from "./resumeDownload.vue?vue&type=template&id=5b45d0ca&scoped=true"
import script from "./resumeDownload.vue?vue&type=script&lang=js"
export * from "./resumeDownload.vue?vue&type=script&lang=js"
import style0 from "./resumeDownload.vue?vue&type=style&index=0&id=5b45d0ca&prod&lang=less&scoped=true"
import style1 from "./resumeDownload.vue?vue&type=style&index=1&id=5b45d0ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b45d0ca",
  null
  
)

export default component.exports